import React from 'react';
import ReactDOM from 'react-dom';
import Routers from './routers';
import * as Sentry from "@sentry/react";
import { initOmega } from '@/common/js/omega'
import { BrowserRouter as Router } from "react-router-dom";
import { getCookie, getIpData } from '@/common/utils/commonFunc';
import { ENV } from '@/common/js/const'
import { Provider } from 'mobx-react';
import { message } from "antd";
import { stores } from "./stores";
import {
    getAppolloConfig
  } from '@/common/js/api';
import { i18nStart, i18nSetLang } from "@didi/i18n-plugin";
import '@/common/css/rtl.less';
import '@/common/css/reset.less';
import '@/common/css/theme.less';
import { Integrations } from "@sentry/tracing";
import { trackLocalStorage } from "@/common/utils/trackLocalStorage";

try {
    getAppolloConfig();
} catch (err) {
    try {
        (window as any)?.SuperOmega?.trackDiyError?.({
            tagName: 'apollo_get_error',
            info: 'apollo_get_error',
            data: err
          });
    } catch {}
};


Sentry.init({
    dsn: "https://2a90cfd6bb3749cfb5313d417bf2bfe0@sentry-us.didiglobal.com/71",
    integrations: [new Integrations.BrowserTracing({
        tracingOrigins: [window.location.origin]
    }) as any],
    ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'UnhandledRejection',
    ],
    tracesSampleRate: 0.01,
    release: 'cs-micro-front-end@0.1.0'
});

// sentry警报触发者的名字上报
Sentry.setUser({ username: getCookie('user_name') });

// message 全局设置
message.config({
	duration: 5,
    maxCount: 3,
});

i18nStart(require("./locales/i18n-index"), require("./locales/i18n-info"));
i18nSetLang(getCookie('lang') || 'en-US');
if (ENV === 'development') { //本地开发请求cstest接口，使用公共测试账号
	// setCookie('user_name', 'fe_test_v', 24)
	// setCookie('userid', '1354688', 24)
    // 提交
}
initOmega()

window.addEventListener('load', ()=>{
  trackLocalStorage('cross-v2')
})

ReactDOM.render(
	<Provider {...stores}>
		<Router>
			<Routers />
		</Router>
	</Provider>,
	document.getElementById('root'));

getIpData();
